/* eslint-disable */
import { Modal, Table, Dropdown, message } from "antd";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
  useRef,
} from "react";

import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import moment from "moment";
import {
  MenuOutlined,
  SolutionOutlined,
  EditOutlined,
  ExclamationCircleFilled,
  ToolOutlined,
  FieldTimeOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./index.css";
import commonFn from "@/utils/commonFn";
import PswModal from "./PswModal";
import AddModal from "./AddModal";
import OffModal from "./OffModal";
import UpdateModal from "./UpdateModal";
const MainTable = forwardRef((props, ref) => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]); // 筛选后的数据
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 13,
  });
  const [tableLoading, setTableLoading] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [loading, setLoading] = useState(false);
  const initialTableHead = {
    taskName: null,
    taskKey: null,
    taskType: null,
    enabled: null,
    cronExpression: null,
    runAtMillis: null,
    trustName: null,
  };
  const [tableHead, setTableHead] = useState(initialTableHead);
  const navigate = useNavigate();
  const pswModalRef = useRef();
  const addModalRef = useRef();
  const roleModalRef = useRef();
  const updateModalRef = useRef();
  const items = [
    {
      key: "delete",
      icon: <EditOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Delete Cron</div>,
    },
    {
      key: "update",
      icon: <SolutionOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>View/Edit Cron</div>,
    },
    {
      key: "on&off",
      icon: <ToolOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Turn On/Off Scheduled Tasks</div>,
    },
     {
      key: "once",
      icon: <FieldTimeOutlined style={{ color: "#00c0ef", fontSize: "17px" }} />,
      label: <div>Perform A Timed Task</div>,
    },
  ];
  const taskTypeKList = [
    { value: "ONCE_NOW", label: "ONCE_NOW" },
    { value: "ONCE_AT", label: "ONCE_AT" },
    { value: "CRON", label: "CRON" },
  ];
const enabledList = [
  { value: "false", label: "OFF" },
  { value: "true", label: "ON" },
];
  // 暴露子组件方法
  useImperativeHandle(ref, () => ({
    getValue: () => columns,
    toggleColumnVisibility: (checkedValues) => {
      setColumns((prevColumns) => {
        return prevColumns.map(
          (col) =>
            checkedValues.includes(col.key)
              ? { ...col, hidden: false } // 如果列的 key 在 checkedValues 中，显示该列
              : { ...col, hidden: true } // 否则隐藏该列
        );
      });
    },

    newListFun: () => {
      //刷新列表
      setTableHead(initialTableHead);
      getTableListFn(1, 25, initialTableHead);
    },
    showModalAdd: () => {
      addModalRef.current?.setModelAdd();
    },
  }));

  // 定义列，包括输入框
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({ event, key, type, setTableHead, getTableListFn });
  };
  const initColumns = [
    {
      title: "Action",
      key: "action",
      dataIndex: "propId",
      align: "center",
      width: 60,
      render: (text, record, index) => (
        <Dropdown menu={menuProps(record)} trigger={["click"]}>
          <MenuOutlined className="col-blue" />
        </Dropdown>
      ),
    },
    {
      title: "Task Name",
      dataIndex: "taskName",
      key: "taskName",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "taskName"),
      render: (text) => text,
    },
    {
      title: "TasK Key",
      dataIndex: "taskKey",
      key: "taskKey",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "taskKey"),
      render: (text) => text,
    },
  {
  title: "Enabled",
  dataIndex: "enabled",
  key: "enabled",
  titleType: "Select",
  width: 200,
  align: "center",
  selectOptions: enabledList,
  onChange: (e) => tableFilterFn(e, "enabled", "Select"),
  render: (text) => (text ? "ON" : "OFF")
},
    {
      title: "TasK Type",
      dataIndex: "taskType",
      key: "taskType",
      titleType: "Select", 
      width: 200,
      align: "center",
      selectOptions: taskTypeKList,
      onChange: (e) => tableFilterFn(e, "taskType", "Select"),
      render: (text) => text,
    },
 
    {
      title: "Cron Expression",
      dataIndex: "cronExpression",
      key: "cronExpression",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "cronExpression"),
      render: (text) => text,
    },
    {
      title: "Cron Remark",
      dataIndex: "cronRemark",
      key: "cronRemark",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "cronRemark"),
      render: (text) => text,
    },
    {
      title: "Run At",
      dataIndex: "runAtMillis",
      key: "runAtMillis",
      titleType: "Input",
      width: 200,
      align: "center",
      onChange: (e) => tableFilterFn(e, "runAtMillis"),
      render: (text) => {
        if (!text) return "-";
        return moment(parseInt(text)).format("YYYY-MM-DD HH:mm:ss");
      },
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));
  //初始化数据
  const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 16,
    },
  };

  const menuProps = (record) => ({
    items,
    onClick: (e) => handleMenuClick(e, record),
  });

  //Action
  const handleMenuClick = async (e, record) => {
    if (e.key === "delete") {
      // setCurrentRecord(record);
      // pswModalRef.current?.setModelReset(true, record);
      showDeleteConfirm(record);
    }

    if (e.key === "update") {
      updateModalRef.current?.showModal(record);
    }
    if (e.key === "on&off") {
      console.log(record);
      roleModalRef.current?.showModal(record);
    }
    if(e.key ==='once'){
showOnceConfirm(record)
    }

  };
  // 显示删除确认对话框
  const showDeleteConfirm = (record) => {
    Modal.confirm({
      title: "Confirm Deletion",
      icon: <ExclamationCircleFilled />,
      content: <span>Do you want to delete this data record?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        setLoading(true);
        try {
          const params = {
            id: record.id,
          };
          console.log(params);
          const response = await http.get(api.getCronJobDelete, { params });
          if (response && response.code == 1) {
            message.success("Successfully delete.");
             getTableListFn(pagination.current, pagination.pageSize);
            setLoading(false);
          } else {
            message.error(response.msg);
          }
        } catch (error) {
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
       
      },
      style: {
        top: "40%",
      },
    });
  };
  // 显示执行一次定时任务弹窗
   const showOnceConfirm = (record) => {
    Modal.confirm({
      title: "Confirm Deletion",
      icon: <ExclamationCircleFilled />,
      content: <span>Execute the scheduled task?</span>,
      okText: "Sure",
      cancelText: "Cancel",
      async onOk() {
        setLoading(true);
        try {
          const params = {
            id: record.id,
          };
          console.log(params);
          const response = await http.get(api.getCronRunNow, { params });
          if (response && response.code == 1) {
            message.success("Successfully delete.");
              getTableListFn(pagination.current, pagination.pageSize);
            setLoading(false);
          } else {
            message.error(response.msg);
          }
        } catch (error) {
          message.error("An error occurred. Please try again.");
        } finally {
          setLoading(false);
        }
      },
      onCancel() {
        console.log("Cancel");
      
      },
      style: {
        top: "40%",
      },
    });
  };

  const { confirm } = Modal;
  useEffect(() => {
    getTableListFn(pagination.current, pagination.pageSize);
  }, []);
  //列表
  const getTableListFn = async (page, pageSize, params = tableHead) => {
    setTableLoading(true);
    try {
      console.log("=====请求table======");
      const queryParams = {
        page,
        count: pageSize,
        taskName: params?.taskName || "",
        taskKey: params?.taskKey || "",
        taskType: params?.taskType || "",
        enabled: params?.enabled || "",
        cronExpression: params?.cronExpression || "",
        runAtMillis: params?.runAtMillis || "",
        trustName: params?.trustName || "",
      };
      const response = await http.get(api.getCronJobShow, {
        params: queryParams,
      });
      const dataWithKey = (response.data.list || [])?.map((item) => ({
        ...item,
        key: item.id,
      }));
      setFilteredData(dataWithKey);
      setPagination((prev) => ({
        ...prev,
        current: page,
        total: response.data.total || 0,
        pageSize: pageSize,
      }));
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  // 子组件回调
  const handleRoleUpdateSuccess = () => {
    getTableListFn(pagination.current, pagination.pageSize);
  };
  // 处理分页变化
  const handleTableChange = (pagination, filters, sorter) => {
    console.log("页码更新");
    console.log(filters);
    //table筛选
    console.log("Sorter:", sorter); //可选值为 ['ascend'升序, 'descend'降序, undefined未选中] 或自定义顺序。
    console.log(pagination);
    getTableListFn(pagination.current, pagination.pageSize);
  };

  return (
    <div>
      <Table
        loading={tableLoading}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={{
          showQuickJumper: true,
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          showTotal: (total) => {
            return `Total: ${total} items`;
          },
        }}
        rowKey="id" // 唯一标识
        onChange={handleTableChange} // 分页、排序、筛选变化时触发
        scroll={{
          x: "max-content", //横向滚动宽度
          y: "calc(100vh - 350px)", //纵向滚动高度
        }}
        className="my-Table"
      />

      <AddModal ref={addModalRef} onSuccess={handleRoleUpdateSuccess} />
      <PswModal
        ref={pswModalRef}
        record={currentRecord}
        onSuccess={handleRoleUpdateSuccess}
      />
      <OffModal ref={roleModalRef} onSuccess={handleRoleUpdateSuccess} />
      <UpdateModal ref={updateModalRef} onSuccess={handleRoleUpdateSuccess} />
    </div>
  );
});
export default MainTable;
